import React, { useState } from "react";
import {
  SwipeableDrawer,
  Box,
  Typography,
  IconButton,
  Tabs,
  Tab,
  Divider,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import InfoIcon from "@mui/icons-material/Info";

const RoundFlightDetailsDrawer = ({ open, onClose, onOpen, content }) => {
  const [activeTab, setActiveTab] = useState(0);

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  return (
    <SwipeableDrawer
      anchor="right"
      open={open}
      onClose={onClose}
      onOpen={onOpen}
      sx={{ zIndex: 1300 }}
    >
      <Box sx={{ width: 850, p: 3 }}>
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Typography variant="h6" fontWeight="bold" fontFamily={"open sans"}>
            Flight Details
          </Typography>
          <IconButton onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </Box>
        <Box>
          <>
            <Tabs
              value={activeTab}
              onChange={handleTabChange}
              textColor="primary"
              indicatorColor="primary"
            >
              <Tab label="Segments" />
              <Tab label="Fare Rules" />
              <Tab label="Free Baggage" />
            </Tabs>
            <Box>
              {activeTab === 0 && (
                <Box>
                  <Box
                    sx={{
                      height: "50px",
                      width: "100%",
                      background: "#f4f6f8",
                      px: 2,
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <Box
                      display={"flex"}
                      flexDirection={"row"}
                      gap={2}
                      alignItems={"center"}
                    >
                      {/* Image box */}
                      <Box
                        sx={{
                          width: "40px",
                          height: "40px",
                          background: "gray",
                        }}
                      ></Box>
                      <Box>
                        <Typography sx={{}}>SpiceJet</Typography>
                        <Typography sx={{}}>SG- 937</Typography>
                      </Box>
                    </Box>

                    <Box
                      display={"flex"}
                      flexDirection={"row"}
                      gap={2}
                      alignItems={"center"}
                    >
                      <Box>
                        <Typography fontWeight={700}>Aircraft</Typography>
                        <Typography sx={{}}>Boeing</Typography>
                      </Box>
                      <Box>
                        <Typography fontWeight={700}>Travel Class</Typography>
                        <Typography sx={{}}>Economy</Typography>
                      </Box>
                    </Box>
                  </Box>
                  <Box
                    sx={{
                      // height: "50px",
                      width: "100%",
                      background: "white",
                      display: "flex",
                      justifyContent: "space-between",
                      flexDirection: "row",
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        textAlign: "right",
                        flexDirection: "column",
                      }}
                    >
                      <Typography>06:00</Typography>
                      <Typography>Sat, 28 Dec 24</Typography>
                      <Typography>Pune - Poona [PNQ]</Typography>
                      <Typography>Lohegaon |Pune - Poona |IN |India</Typography>
                    </Box>
                    <Box>
                      <Typography>2Hr. 10 Min.</Typography>
                    </Box>
                    <Box>
                      <Typography>06:00</Typography>
                      <Typography>Sat, 28 Dec 24</Typography>
                      <Typography>Pune - Poona [PNQ]</Typography>
                      <Typography>Lohegaon |Pune - Poona |IN |India</Typography>
                    </Box>
                  </Box>
                  <Box
                    display={"flex"}
                    flexDirection={"row"}
                    alignItems={"center"}
                    gap={2}
                  >
                    <InfoIcon sx={{ color: "#027BFE" }} />
                    <Typography sx={{ color: "#027BFE", mt: 2, mb: 2 }}>
                      Meal, seat, Rescheduling & Cancellation are chargeable.
                    </Typography>
                  </Box>

                  {/* ----------------------------------------------------------------------------------------------- */}
                  <Box
                    sx={{
                      height: "50px",
                      width: "100%",
                      background: "#f4f6f8",
                      px: 2,
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <Box
                      display={"flex"}
                      flexDirection={"row"}
                      gap={2}
                      alignItems={"center"}
                    >
                      {/* Image box */}
                      <Box
                        sx={{
                          width: "40px",
                          height: "40px",
                          background: "gray",
                        }}
                      ></Box>
                      <Box>
                        <Typography sx={{}}>SpiceJet</Typography>
                        <Typography sx={{}}>SG- 937</Typography>
                      </Box>
                    </Box>

                    <Box
                      display={"flex"}
                      flexDirection={"row"}
                      gap={2}
                      alignItems={"center"}
                    >
                      <Box>
                        <Typography fontWeight={700}>Aircraft</Typography>
                        <Typography sx={{}}>Boeing</Typography>
                      </Box>
                      <Box>
                        <Typography fontWeight={700}>Travel Class</Typography>
                        <Typography sx={{}}>Economy</Typography>
                      </Box>
                    </Box>
                  </Box>
                  <Box
                    sx={{
                      // height: "50px",
                      width: "100%",
                      background: "white",
                      display: "flex",
                      justifyContent: "space-between",
                      flexDirection: "row",
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        textAlign: "right",
                        flexDirection: "column",
                      }}
                    >
                      <Typography>06:00</Typography>
                      <Typography>Sat, 28 Dec 24</Typography>
                      <Typography>Pune - Poona [PNQ]</Typography>
                      <Typography>Lohegaon |Pune - Poona |IN |India</Typography>
                    </Box>
                    <Box>
                      <Typography>2Hr. 10 Min.</Typography>
                    </Box>
                    <Box>
                      <Typography>06:00</Typography>
                      <Typography>Sat, 28 Dec 24</Typography>
                      <Typography>Pune - Poona [PNQ]</Typography>
                      <Typography>Lohegaon |Pune - Poona |IN |India</Typography>
                    </Box>
                  </Box>
                  <Box
                    display={"flex"}
                    flexDirection={"row"}
                    alignItems={"center"}
                    gap={2}
                  >
                    <InfoIcon sx={{ color: "#027BFE" }} />
                    <Typography sx={{ color: "#027BFE", mt: 2, mb: 2 }}>
                      Meal, seat, Rescheduling & Cancellation are chargeable.
                    </Typography>
                  </Box>
                </Box>
              )}
              {activeTab === 1 && (
                <Typography variant="body2">
                  Fare Rules content here
                  {/* {content.fareRules || "No fare rules available."} */}
                </Typography>
              )}
              {activeTab === 2 && (
                <Typography variant="body2">
                  Free Baggage content here
                  {/* {content.freeBaggage ||
                    "No free baggage information available."} */}
                </Typography>
              )}
            </Box>
          </>
          {/* {content ? (
            <>
              <Tabs
                value={activeTab}
                onChange={handleTabChange}
                textColor="primary"
                indicatorColor="primary"
              >
                <Tab label="Segments" />
                <Tab label="Fare Rules" />
                <Tab label="Free Baggage" />
              </Tabs>
              <Box mt={2}>
                {activeTab === 0 && (
                  <Typography variant="body2">
                    {content.segments || "No segments available."}
                  </Typography>
                )}
                {activeTab === 1 && (
                  <Typography variant="body2">
                    {content.fareRules || "No fare rules available."}
                  </Typography>
                )}
                {activeTab === 2 && (
                  <Typography variant="body2">
                    {content.freeBaggage ||
                      "No free baggage information available."}
                  </Typography>
                )}
              </Box>
            </>
          ) : (
            <Typography variant="body2" color="textSecondary">
              No flight details available.
            </Typography>
          )} */}
        </Box>
      </Box>
    </SwipeableDrawer>
  );
};

export default RoundFlightDetailsDrawer;
